import { Platform } from 'react-native'

// Native driver есть только на iOS/Android. На web RN Animated всё равно падает на JS
// и пишет warning, если передать true.
export const USE_NATIVE_DRIVER = Platform.OS !== 'web'
